module.exports = __webpack_public_path__ + "static/carousel-02@2x-ead6c29f1e530a2b3bd12909b54ce67d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/about-us/carousel-02@2x.jpg
// module id = 2519
// module chunks = 168707334958949